import Fullpage from './../components/Fullpage'
import hero from './../sections/hero'
import photos from './../sections/photos'
import map from './../sections/map'
import features from './../sections/features'
import building from './../sections/building'
import gallery from './../sections/gallery'
import downloads from './../sections/downloads'
import Modals from './../components/modals'
import sustainability from './../sections/sustainability'
import specifications from './../sections/specifications'
import GreetingAnimation from './../components/GreetingAnimation'

export default () => {

  const fullpage = new Fullpage();
  fullpage.init()

  hero()
  photos()
  map()
  features()
  building()
  gallery()
  downloads()
  sustainability()
  specifications()

  const modals = new Modals();
  modals.init()

  if (document.documentElement.clientWidth < 640) {
    document.body.style.overflow = 'hidden';
  }
  window.addEventListener('preloaderComplete', () => {
    document.body.style.overflow = '';
  })

  const preloader = new GreetingAnimation();
  preloader.init()

}
